import React, { Component } from "react";

export default class BlogsImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
    <g id="freepik--background-complete--inject-227">
      <rect
        y={382.4}
        width={500}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <rect
        x={72.44}
        y={391.89}
        width={34.4}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <rect
        x={287.94}
        y={393.67}
        width={10.28}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <rect
        x={117.3}
        y={395.45}
        width={19.36}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <rect
        x={394.11}
        y={394.86}
        width={25.68}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <rect
        x={359.06}
        y={391.31}
        width={17.54}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <rect
        x={179.81}
        y={390.91}
        width={93.68}
        height={0.25}
        fill={theme.compImgHighlight}
      />
      <path
        d="M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M343.82,284.61h0c-.55,0-1.1,0-1.66.05A23.68,23.68,0,0,0,321,314.44a118.6,118.6,0,0,1,3.71,30.84v30.28a4,4,0,0,0,4,4h96.11V284.61Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M448.43,308.28a23.67,23.67,0,0,0-47.29-1.54,23.37,23.37,0,0,0,.76,7.7,118.6,118.6,0,0,1,3.71,30.84v30.28a4,4,0,0,0,4,4h30.35a4,4,0,0,0,4-4V343.5a108.19,108.19,0,0,1,3.66-28.89A23.65,23.65,0,0,0,448.43,308.28Z"
        fill={theme.compImgHighlight}
      />
      <rect
        x={223.13}
        y={321.9}
        width={169.01}
        height={57.63}
        fill={theme.compImgHighlight}
      />
      <path
        d="M169.75,252.86H332.12A17.92,17.92,0,0,1,350,270.78v64.15a0,0,0,0,1,0,0H151.83a0,0,0,0,1,0,0V270.78A17.92,17.92,0,0,1,169.75,252.86Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M191.44,252.86h164.1a17.05,17.05,0,0,1,17.05,17.05v65a0,0,0,0,1,0,0H174.39a0,0,0,0,1,0,0v-65A17.05,17.05,0,0,1,191.44,252.86Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M228.78,316.64H391a5.2,5.2,0,0,1,5.2,5.2v13.07a5.2,5.2,0,0,1-5.2,5.2H228.78a1.55,1.55,0,0,1-1.55-1.55V318.19A1.55,1.55,0,0,1,228.78,316.64Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M143.32,284.61h0c-.55,0-1.1,0-1.66.05a23.68,23.68,0,0,0-21.2,29.77,118.6,118.6,0,0,1,3.71,30.84v30.28a4,4,0,0,0,4,4h96.11V284.61Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M247.93,308.28a23.67,23.67,0,0,0-47.29-1.54,23.37,23.37,0,0,0,.76,7.7,118.6,118.6,0,0,1,3.71,30.84v30.28a4,4,0,0,0,4,4h30.35a4,4,0,0,0,4-4V343.5a108.19,108.19,0,0,1,3.66-28.89A23.65,23.65,0,0,0,247.93,308.28Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M423.07,382.41H145a2.88,2.88,0,0,1-2.88-2.88H426A2.88,2.88,0,0,1,423.07,382.41Z"
        fill={theme.compImgHighlight}
      />
      <rect
        x={119.9}
        y={112.33}
        width={171.15}
        height={83.34}
        fill={theme.compImgHighlight}
      />
      <rect
        x={125.62}
        y={112.33}
        width={173.65}
        height={83.34}
        fill={theme.compImgHighlight}
      />
      <rect
        x={177.34}
        y={73.75}
        width={70.21}
        height={160.51}
        transform="translate(366.45 -58.44) rotate(90)"
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={194.35}
        y={89.57}
        width={36.17}
        height={128.87}
        rx={11.81}
        transform="translate(366.45 -58.44) rotate(90)"
        fill={theme.compImgHighlight}
      />
      <rect
        x={332.01}
        y={162.89}
        width={40.77}
        height={42.24}
        fill={theme.compImgHighlight}
      />
      <rect
        x={337.2}
        y={162.89}
        width={39.74}
        height={42.24}
        fill={theme.compImgHighlight}
      />
      <rect
        x={339.28}
        y={167.47}
        width={35.59}
        height={33.08}
        transform="translate(541.08 -173.06) rotate(90)"
        style={{
          fill: "#fff",
        }}
      />
      <polygon
        points="357.07 175.02 348.02 190.69 366.12 190.69 357.07 175.02"
        fill={theme.compImgHighlight}
      />
      <rect
        x={386.34}
        y={135.2}
        width={40.77}
        height={42.24}
        fill={theme.compImgHighlight}
      />
      <rect
        x={391.54}
        y={135.2}
        width={39.74}
        height={42.24}
        fill={theme.compImgHighlight}
      />
      <rect
        x={393.61}
        y={139.78}
        width={35.59}
        height={33.08}
        transform="translate(567.73 -255.08) rotate(90)"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M415.45,162.67l3.93-6.8a4.67,4.67,0,0,0-4.05-7h-7.85a4.67,4.67,0,0,0-4.05,7l3.93,6.8A4.67,4.67,0,0,0,415.45,162.67Z"
        fill={theme.compImgHighlight}
      />
      <rect
        x={35.05}
        y={308}
        width={22.57}
        height={69.97}
        fill={theme.compImgHighlight}
      />
      <rect
        x={39.38}
        y={377.97}
        width={111.28}
        height={4.43}
        fill={theme.compImgHighlight}
      />
      <rect
        x={57.62}
        y={308}
        width={97.38}
        height={69.97}
        transform="translate(212.62 685.97) rotate(180)"
        fill={theme.compImgHighlight}
      />
      <rect
        x={66.49}
        y={316.61}
        width={79.64}
        height={22.95}
        transform="translate(212.62 656.17) rotate(180)"
        fill={theme.compImgHighlight}
      />
      <rect
        x={66.49}
        y={346.41}
        width={79.64}
        height={22.95}
        transform="translate(212.62 715.76) rotate(180)"
        fill={theme.compImgHighlight}
      />
      <path
        d="M115.88,329.66H96.74a1.58,1.58,0,0,1-1.57-1.58h0a1.58,1.58,0,0,1,1.57-1.57h19.14a1.58,1.58,0,0,1,1.57,1.57h0A1.58,1.58,0,0,1,115.88,329.66Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M115.88,359.45H96.74a1.57,1.57,0,0,1-1.57-1.57h0a1.57,1.57,0,0,1,1.57-1.57h19.14a1.57,1.57,0,0,1,1.57,1.57h0A1.57,1.57,0,0,1,115.88,359.45Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M87.86,256.67h-13c.37,12.6-5.38,19.72-5.38,34.55,0,13.34,3.26,15.84,11.89,15.84s11.89-2.5,11.89-15.84C93.24,276.39,87.48,269.27,87.86,256.67Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M76.63,306.58h9.44a0,0,0,0,1,0,0v.8a.62.62,0,0,1-.62.62h-8.2a.62.62,0,0,1-.62-.62v-.8A0,0,0,0,1,76.63,306.58Z"
        style={{
          fill: "#f3f7ff",
        }}
      />
      <rect
        x={66.03}
        y={261.26}
        width={1}
        height={19.13}
        fill={theme.compImgHighlight}
      />
      <polygon
        points="102.01 267.28 60.68 267.28 67.77 224.92 94.93 224.92 102.01 267.28"
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Shadow--inject-227">
      <ellipse
        cx={250}
        cy={416.24}
        rx={193.89}
        ry={11.32}
        fill={theme.compImgHighlight}
      />
    </g>
    <g id="freepik--Plant--inject-227">
      <path
        d="M242.35,386.62c-.94-32.63-2.14-189.64-.26-206l3.75-4.09s-.09,4.69-.18,17.18c-.39,55.9-1.84,184.57-1.52,192.88Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M242.35,386.62c-.94-32.63-2.14-189.64-.26-206l3.75-4.09s-.09,4.69-.18,17.18c-.39,55.9-1.84,184.57-1.52,192.88Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M257.66,293.8A123.67,123.67,0,0,1,289.12,271c8.63-4.22-14,23.34-22.86,33.61S246.5,326.23,243,335.82C242.3,316.28,246.74,304.67,257.66,293.8Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M257.66,293.8A123.67,123.67,0,0,1,289.12,271c8.63-4.22-14,23.34-22.86,33.61S246.5,326.23,243,335.82C242.3,316.28,246.74,304.67,257.66,293.8Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M242.91,210.39c-6.74-29.74-4.66-46.84,2.93-65.17,7.1-17.14,12.64-24.8,20.89-31.29,2.13-1.67-2.66,22.29-10,40.15-5.18,12.6-7.75,29-11.33,38.44C242.91,199,242.91,210.39,242.91,210.39Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M242.91,210.39c-6.74-29.74-4.66-46.84,2.93-65.17,7.1-17.14,12.64-24.8,20.89-31.29,2.13-1.67-2.66,22.29-10,40.15-5.18,12.6-7.75,29-11.33,38.44C242.91,199,242.91,210.39,242.91,210.39Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M243.27,275.56c-.74-17.8-1.63-35,11.9-57.61,3.29-5.51,32.4-52,42.45-54.8,4.93-1.36-3.83,34.61-17.29,56.08-10.1,16.09-14.76,20.35-25.81,39.13C250.17,265.76,243.27,275.56,243.27,275.56Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M243.27,275.56c-.74-17.8-1.63-35,11.9-57.61,3.29-5.51,32.4-52,42.45-54.8,4.93-1.36-3.83,34.61-17.29,56.08-10.1,16.09-14.76,20.35-25.81,39.13C250.17,265.76,243.27,275.56,243.27,275.56Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M225.89,202.05c-11.88-11.46-23.53-19-32.16-22.81s14.09,24.7,25,37.08,20.91,23.12,25.19,34.14C242.69,226.85,237.78,213.52,225.89,202.05Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M225.89,202.05c-11.88-11.46-23.53-19-32.16-22.81s14.09,24.7,25,37.08,20.91,23.12,25.19,34.14C242.69,226.85,237.78,213.52,225.89,202.05Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M243.93,309.32C242,295.91,237.6,280.6,230.85,270s-17.14-26.76-25.74-31.13c-2.06-1.05,9.31,31.7,14.82,40.76a98.76,98.76,0,0,0,16.31,20.39C237.7,301.53,243.93,309.32,243.93,309.32Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M243.93,309.32C242,295.91,237.6,280.6,230.85,270s-17.14-26.76-25.74-31.13c-2.06-1.05,9.31,31.7,14.82,40.76a98.76,98.76,0,0,0,16.31,20.39C237.7,301.53,243.93,309.32,243.93,309.32Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <polygon
        points="258.38 395.08 228.14 395.08 225.86 362.5 260.66 362.5 258.38 395.08"
        fill={theme.imageHighlight}
      />
      <polygon
        points="262.91 367.99 223.61 367.99 222.48 359.5 264.04 359.5 262.91 367.99"
        fill={theme.imageHighlight}
      />
      <g
        opacity={0.4}
      >
        <polygon points="258.38 395.08 228.14 395.08 225.86 362.5 260.66 362.5 258.38 395.08" />
        <polygon points="262.91 367.99 223.61 367.99 222.48 359.5 264.04 359.5 262.91 367.99" />
      </g>
    </g>
    <g id="freepik--Character--inject-227">
      <path
        d="M291.08,273.32c-9.3,1.67-39.64-17.21-49.91-29.64a154.09,154.09,0,0,0,20.16-21.09c-6.66,7.63-17.36,14.4-23.71,18-2.87-2.48-4.55-4-4.55-4s26-8.71,39.82-39.34c10.53-23.31,25.83-35.82,42-23.84C346.33,181.11,313,263.73,291.08,273.32Z"
        fill={theme.text}
      />
      <path
        d="M300.45,223c-.25.37-.4.59-.6.85l-.55.74c-.38.48-.76.93-1.15,1.38-.79.9-1.59,1.76-2.43,2.58a50.4,50.4,0,0,1-5.4,4.51,48.9,48.9,0,0,1-6,3.64c-1.06.51-2.11,1-3.2,1.45l-1.63.64-.43.17c-.26.08-.48.16-.77.23a5.76,5.76,0,0,1-2,.15,5.27,5.27,0,0,1-2.32-.82,5.58,5.58,0,0,1-1.49-1.51,7.73,7.73,0,0,1-1.07-2.6,17,17,0,0,1-.35-4,44.42,44.42,0,0,1,.76-6.89c.41-2.21.89-4.37,1.43-6.51s1.16-4.24,1.89-6.36l3.75.91c-.27,2.1-.57,4.23-.77,6.35s-.45,4.22-.57,6.31a49.11,49.11,0,0,0-.05,6.05,10.68,10.68,0,0,0,.4,2.45c.09.29.22.48.18.37a1,1,0,0,0-.35-.36,1.73,1.73,0,0,0-.8-.31,1.3,1.3,0,0,0-.4,0s0,0,0,0l.32-.15,1.34-.65c.9-.43,1.76-.93,2.63-1.4a55.38,55.38,0,0,0,4.95-3.31,46.39,46.39,0,0,0,4.45-3.94c.71-.68,1.38-1.4,2-2.13.31-.37.63-.74.92-1.11l.44-.55.36-.46Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M278.55,212.48l3.23-5.79-7.94.48s-.5,3.76,1.68,6.06Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M302.5,213.39c-7.84.31-13.8,7.76-13.8,7.76l10,12.6s7.5-7.56,8.18-11.71C307.61,217.71,307.22,213.2,302.5,213.39Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M302.5,213.39c-7.84.31-13.8,7.76-13.8,7.76l10,12.6s7.5-7.56,8.18-11.71C307.61,217.71,307.22,213.2,302.5,213.39Z"
        opacity={0.30000000000000004}
      />
      <polygon
        points="280.3 203.21 274.48 204.66 273.84 207.17 281.78 206.69 280.3 203.21"
        style={{
          fill: "#e4897b",
        }}
      />
      <polygon
        points="279.75 196.25 280.78 196.79 280.31 204.08 278.01 204.24 279.75 196.25"
        style={{
          fill: "#e4897b",
        }}
      />
      <polygon
        points="278 195.97 276.99 196.21 276.03 204.95 278.3 204.37 278 195.97"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M295.23,215.76s-3.07,2.31,17.32,42.7L342,249.13c-4.29-11.83-6.65-19.23-8.7-45.66a91.31,91.31,0,0,0-13,2.31A97.93,97.93,0,0,0,306.91,210C301.33,212.36,295.23,215.76,295.23,215.76Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M295.23,215.76s-3.07,2.31,17.32,42.7L342,249.13c-4.29-11.83-6.65-19.23-8.7-45.66a91.31,91.31,0,0,0-13,2.31A97.93,97.93,0,0,0,306.91,210C301.33,212.36,295.23,215.76,295.23,215.76Z"
        opacity={0.30000000000000004}
      />
      <polygon
        points="364.09 407.93 356.74 408.64 349.09 391.14 356.44 390.43 364.09 407.93"
        style={{
          fill: "#e4897b",
        }}
      />
      <polygon
        points="349.09 391.15 353.03 400.17 360.7 400.17 356.45 390.43 349.09 391.15"
        style={{
          fill: "#ce6f64",
        }}
      />
      <polygon
        points="430.41 371.81 426.22 378.17 410.16 370.5 414.36 364.15 430.41 371.81"
        style={{
          fill: "#e4897b",
        }}
      />
      <polygon
        points="414.36 364.15 410.17 370.5 418.45 374.45 422.64 368.1 414.36 364.15"
        style={{
          fill: "#ce6f64",
        }}
      />
      <path
        d="M312.55,258.46s-1.48,60.73,6,82.71c7.77,22.86,30.66,56.38,30.66,56.38l14.27-.69s-20.58-42.12-22.9-60.31c-3.18-25.08-6.44-84.92-6.44-84.92Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M312.55,258.46s-1.48,60.73,6,82.71c7.77,22.86,30.66,56.38,30.66,56.38l14.27-.69s-20.58-42.12-22.9-60.31c-3.18-25.08-6.44-84.92-6.44-84.92Z"
        opacity={0.6000000000000001}
      />
      <path
        d="M336.58,290.74l-10.5-24s1.21,27.67,11.28,34.79C337.09,297.93,336.83,294.3,336.58,290.74Z"
        opacity={0.30000000000000004}
      />
      <path
        d="M320.34,256s20,48.47,33.22,75.16c10.7,21.55,61.8,43.69,61.8,43.69l5.36-9s-39.09-24.8-46.48-39.42c-23.65-46.79-18.61-67.13-32.21-77.3Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M320.34,256s20,48.47,33.22,75.16c10.7,21.55,61.8,43.69,61.8,43.69l5.36-9s-39.09-24.8-46.48-39.42c-23.65-46.79-18.61-67.13-32.21-77.3Z"
        opacity={0.6000000000000001}
      />
      <path
        d="M424.45,377.48,425,369a.62.62,0,0,1,.56-.58l6.82-.53a1.22,1.22,0,0,1,1.27,1.3c-.25,3-.51,4.4-.76,8.15-.14,2.31-.13,7.44-.34,10.62s-3.37,3.16-3.57,1.81c-.9-6-2.59-8.83-4.14-10.94A2,2,0,0,1,424.45,377.48Z"
        fill={theme.text}
      />
      <path
        d="M355.76,406.37h9a.76.76,0,0,1,.72.55l2,7.14a1.11,1.11,0,0,1-1.1,1.43c-3.16-.05-4.7-.23-8.67-.23-2.44,0-8.76.25-12.13.25s-4-3.34-2.62-3.64c6.12-1.35,9.65-3.22,11.53-5A1.87,1.87,0,0,1,355.76,406.37Z"
        fill={theme.text}
      />
      <path
        d="M314.2,191.13c.52,4.58,2.17,12.73,6.09,14.65,0,0,.21,4.74-7.79,7.28-8.8,2.78-5.59-3-5.59-3,4.44-2.67,3.19-6.19,1.29-9.27Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M299.31,213.6c2.18-1.12,4.95-2.47,7.6-3.58a98.38,98.38,0,0,1,13.38-4.24c2.58-.68,5.18-1.19,7.37-1.54.47,1.45,2,11.92-13.64,15.79C300.32,223.43,298.59,215.86,299.31,213.6Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M306.34,210.31a.54.54,0,0,1-.36-.14.52.52,0,0,1-.14-.36.5.5,0,0,1,.14-.35.52.52,0,0,1,.71,0,.51.51,0,0,1,.15.35.53.53,0,0,1-.15.36A.5.5,0,0,1,306.34,210.31Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M309.8,216.28a.51.51,0,0,1-.45-.56h0a.5.5,0,0,1,.55-.44h0a.5.5,0,0,1,.45.55h0a.51.51,0,0,1-.5.45h-.05Zm1.55-.48a.51.51,0,0,1,.44-.56h0a.5.5,0,0,1,.55.44h0a.49.49,0,0,1-.44.56h0A.51.51,0,0,1,311.35,215.8Zm2-.3a.5.5,0,0,1,.35-.61h0a.49.49,0,0,1,.61.36h0a.5.5,0,0,1-.35.61h-.13A.5.5,0,0,1,313.33,215.5Zm-5.63.12a.49.49,0,0,1-.18-.68h0a.51.51,0,0,1,.69-.18h0a.5.5,0,0,1,.17.69h0a.49.49,0,0,1-.43.24h0A.47.47,0,0,1,307.7,215.62Zm7.54-.7a.5.5,0,0,1,.26-.66h0a.5.5,0,0,1,.66.26h0a.51.51,0,0,1-.26.66h0a.45.45,0,0,1-.2,0h0A.5.5,0,0,1,315.24,214.92ZM317,214a.5.5,0,0,1,.13-.7h0a.5.5,0,0,1,.69.13h0a.49.49,0,0,1-.12.69h0a.52.52,0,0,1-.29.09h0A.49.49,0,0,1,317,214ZM306.18,214h0a.5.5,0,0,1,.24-.67h0a.49.49,0,0,1,.66.23h0a.5.5,0,0,1-.23.67h0a.54.54,0,0,1-.21.05h0A.5.5,0,0,1,306.18,214Zm12.43-1.16a.49.49,0,0,1,0-.7h0a.48.48,0,0,1,.7,0h0a.5.5,0,0,1,0,.71h0a.5.5,0,0,1-.37.16h0A.51.51,0,0,1,318.61,212.8Zm-12.94-1a.5.5,0,0,1,.47-.53h0a.51.51,0,0,1,.53.48h0a.5.5,0,0,1-.48.52h0A.5.5,0,0,1,305.67,211.83Zm14.23-.56a.5.5,0,0,1-.17-.69h0a.51.51,0,0,1,.69-.16h0a.51.51,0,0,1,.17.69h0a.52.52,0,0,1-.43.24h0A.5.5,0,0,1,319.9,211.27Zm1-1.76a.49.49,0,0,1-.29-.64h0a.49.49,0,0,1,.64-.29h0a.5.5,0,0,1,.29.65h0a.49.49,0,0,1-.47.32h0A.38.38,0,0,1,320.86,209.51Zm.63-1.89a.52.52,0,0,1-.39-.6h0a.5.5,0,0,1,.6-.38h0a.49.49,0,0,1,.38.59h0a.51.51,0,0,1-.49.4h-.1Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M321.89,205.61a.48.48,0,0,1-.5-.5.5.5,0,0,1,.14-.35.57.57,0,0,1,.16-.11.53.53,0,0,1,.55.11.51.51,0,0,1,.15.35.55.55,0,0,1-.15.36.54.54,0,0,1-.16.1A.46.46,0,0,1,321.89,205.61Z"
        fill={theme.compImgHighlight}
      />
      <path
        d="M311.75,195.06l-3.55,5.68a13.79,13.79,0,0,1,1.17,2.25c1.75-.85,4-3.36,3.58-5.35A8,8,0,0,0,311.75,195.06Z"
        style={{
          fill: "#ce6f64",
        }}
      />
      <path
        d="M312.12,181c2.51,7.12,3.73,10.08,1.73,15.13-3,7.59-12.3,9.13-16.89,2.9-4.13-5.6-7.55-16.31-1.93-21.95A10.3,10.3,0,0,1,312.12,181Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M301.74,173.42c-1.57,2.42,4.82,16.42,14.19,13.63,4.69-1.4,3.11-4.53.35-7.31a21.31,21.31,0,0,0-12.3-6Z"
        fill={theme.text}
      />
      <path
        d="M302.1,173.82c-2.76-.27-11.93,1.42-11.53,10.74,0,0,3.81-3.42,14.43-4Z"
        fill={theme.text}
      />
      <path
        d="M315.85,186.75a5.5,5.5,0,0,1-.42,4.2c-.92,1.7-2.77,1.2-3.67-.39-.81-1.44-1.3-4.06.18-5.23A2.49,2.49,0,0,1,315.85,186.75Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M341.92,247.26l2.16,2.22c.17.17,0,.46-.34.57l-30.91,9.78c-.27.08-.53,0-.6-.14l-1.1-2.56c-.08-.17.11-.4.4-.49l29.84-9.44A.56.56,0,0,1,341.92,247.26Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M302.41,187.35c.24.57.13,1.15-.23,1.31s-.87-.18-1.11-.74-.13-1.15.24-1.31S302.17,186.78,302.41,187.35Z"
        fill={theme.text}
      />
      <path
        d="M296,190.06c.24.56.14,1.15-.23,1.31s-.87-.18-1.11-.74-.13-1.15.24-1.31S295.78,189.49,296,190.06Z"
        fill={theme.text}
      />
      <path
        d="M295.1,189.28l-1.53.19S294.72,190.23,295.1,189.28Z"
        fill={theme.text}
      />
      <path
        d="M298.12,190.31a16.73,16.73,0,0,1-.48,4.47,2.62,2.62,0,0,0,2.17-.48Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M302.67,195.7a.17.17,0,0,1-.16-.11.18.18,0,0,1,.09-.24,4.85,4.85,0,0,0,2.91-3.3.17.17,0,0,1,.21-.14.18.18,0,0,1,.15.21,5.19,5.19,0,0,1-3.13,3.56Z"
        fill={theme.text}
      />
      <path
        d="M303.32,184.5a.31.31,0,0,1-.18-.05,2.84,2.84,0,0,0-2.59-.2.36.36,0,1,1-.33-.65,3.57,3.57,0,0,1,3.28.23.36.36,0,0,1,.13.49A.33.33,0,0,1,303.32,184.5Z"
        fill={theme.text}
      />
      <path
        d="M291.73,188.37h-.06a.36.36,0,0,1-.29-.42,3.57,3.57,0,0,1,2-2.64.36.36,0,1,1,.28.66,2.86,2.86,0,0,0-1.53,2.11A.37.37,0,0,1,291.73,188.37Z"
        fill={theme.text}
      />
      <path
        d="M339,210.28c.72.85,1.6,1.81,2.42,2.72s1.71,1.81,2.59,2.69c1.75,1.78,3.55,3.51,5.44,5.12s3.8,3.18,5.8,4.58c.49.37,1,.68,1.52,1s1,.67,1.53,1,1.07.65,1.54.9l.64.33.7.28a17.9,17.9,0,0,0,3.11.82,29.44,29.44,0,0,0,3.45.33,48.82,48.82,0,0,0,7.29-.38,71.26,71.26,0,0,0,7.43-1.28c2.47-.51,5-1.18,7.36-1.87l1.43,3.58a75.76,75.76,0,0,1-7.46,3,77.24,77.24,0,0,1-7.79,2.19,47.85,47.85,0,0,1-8.23,1.13,26.5,26.5,0,0,1-8.83-1l-1.13-.4-1.12-.5c-.7-.33-1.26-.65-1.89-1s-1.23-.66-1.82-1-1.21-.69-1.78-1.07a66.8,66.8,0,0,1-6.67-4.8c-2.11-1.72-4.13-3.54-6.06-5.44q-1.44-1.44-2.82-2.94c-.93-1-1.79-2-2.72-3.15Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M424.44,381.86a1.55,1.55,0,0,1-.29,0,.59.59,0,0,1-.48-.39c-.35-.91,1.29-3.12,1.48-3.37a.17.17,0,0,1,.18-.06.17.17,0,0,1,.14.14c.17,1,.35,2.78-.35,3.45A.93.93,0,0,1,424.44,381.86Zm.74-3.22c-.63.9-1.36,2.19-1.18,2.67,0,.06.07.13.22.16a.68.68,0,0,0,.65-.14C425.25,381,425.36,380,425.18,378.64Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M422.63,380a.78.78,0,0,1-.22,0,.64.64,0,0,1-.46-.64.93.93,0,0,1,.29-.75c.78-.77,3-.64,3.06-.64a.21.21,0,0,1,.15.1.17.17,0,0,1,0,.18A4.79,4.79,0,0,1,422.63,380Zm2.24-1.7a4,4,0,0,0-2.38.55.6.6,0,0,0-.18.47c0,.23.11.29.19.31.52.14,1.81-.64,2.43-1.33Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M351.76,407.86a3,3,0,0,1-1.76-.42,1.09,1.09,0,0,1-.46-.87.51.51,0,0,1,.22-.49c.83-.55,3.9.84,4.51,1.13a.17.17,0,0,1,.1.18.19.19,0,0,1-.14.16A11.8,11.8,0,0,1,351.76,407.86Zm-1.44-1.56a.65.65,0,0,0-.35.08.16.16,0,0,0-.07.17.73.73,0,0,0,.31.6c.71.54,2.41.34,3.39.16A11,11,0,0,0,350.32,406.3Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M354.19,407.55h-.07c-1-.42-3.07-2.06-3-2.92,0-.18.15-.42.62-.47,1.79-.23,2.55,3,2.59,3.18a.18.18,0,0,1-.18.22Zm-2.25-3.05h-.12c-.19,0-.29.07-.3.16-.07.5,1.35,1.8,2.39,2.37C353.67,406.25,353,404.5,351.94,404.5Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M391.67,225.11l-2.16-5.34-3.62,6.84s2.22,3.77,5.37,3.49l.49-1.39A5.13,5.13,0,0,0,391.67,225.11Z"
        style={{
          fill: "#e4897b",
        }}
      />
      <path
        d="M301.48,186.57l-1.52.19S301.11,187.52,301.48,186.57Z"
        fill={theme.text}
      />
      <polygon
        points="364.49 397.28 347.46 398.18 345 393.46 363.48 392.85 364.49 397.28"
        fill={theme.imageHighlight}
      />
      <polygon
        points="364.49 397.28 347.46 398.18 345 393.46 363.48 392.85 364.49 397.28"
        style={{
          fill: "#fff",
          opacity: 0.7000000000000001,
        }}
      />
      <polygon
        points="421.95 364.67 415.08 375.94 411.46 375.19 417.9 361.96 421.95 364.67"
        fill={theme.imageHighlight}
      />
      <polygon
        points="421.95 364.67 415.08 375.94 411.46 375.19 417.9 361.96 421.95 364.67"
        style={{
          fill: "#fff",
          opacity: 0.7000000000000001,
        }}
      />
      <path
        d="M339,251.87l.8-.25c.16-.05.25-.17.21-.27L338.52,248c0-.1-.21-.13-.37-.08l-.8.25c-.16,0-.25.17-.21.27l1.46,3.31C338.64,251.88,338.81,251.92,339,251.87Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M315.16,259.4l.8-.25c.16,0,.26-.17.22-.27l-1.46-3.31c-.05-.1-.21-.13-.37-.08l-.8.25c-.16,0-.25.17-.21.27l1.46,3.31C314.84,259.41,315,259.45,315.16,259.4Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M327.07,255.64l.8-.26c.15,0,.25-.17.21-.27l-1.46-3.3c0-.1-.21-.14-.37-.09l-.8.25c-.16.05-.25.18-.21.27l1.46,3.31C326.74,255.65,326.91,255.69,327.07,255.64Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M339,251.87l.8-.25c.16-.05.25-.17.21-.27L338.52,248c0-.1-.21-.13-.37-.08l-.8.25c-.16,0-.25.17-.21.27l1.46,3.31C338.64,251.88,338.81,251.92,339,251.87Z"
        opacity={0.6000000000000001}
      />
      <path
        d="M315.16,259.4l.8-.25c.16,0,.26-.17.22-.27l-1.46-3.31c-.05-.1-.21-.13-.37-.08l-.8.25c-.16,0-.25.17-.21.27l1.46,3.31C314.84,259.41,315,259.45,315.16,259.4Z"
        opacity={0.6000000000000001}
      />
      <path
        d="M327.07,255.64l.8-.26c.15,0,.25-.17.21-.27l-1.46-3.3c0-.1-.21-.14-.37-.09l-.8.25c-.16.05-.25.18-.21.27l1.46,3.31C326.74,255.65,326.91,255.69,327.07,255.64Z"
        opacity={0.6000000000000001}
      />
      <path
        d="M333.33,203.47c3.23,0,10,9,10,9l-8.87,11.82s-5.66-7.38-5.63-11.59C328.87,208.33,329.63,203.51,333.33,203.47Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M333.33,203.47c3.23,0,10,9,10,9l-8.87,11.82s-5.66-7.38-5.63-11.59C328.87,208.33,329.63,203.51,333.33,203.47Z"
        opacity={0.30000000000000004}
      />
      <path
        d="M386.54,219.49l-.08,5.38a1.2,1.2,0,0,0,.22.69l1.95,2.73.88-8.52-1-1.05A1.16,1.16,0,0,0,386.54,219.49Z"
        style={{
          fill: "#e4897b",
        }}
      />
    </g>
    <g id="freepik--blog-post--inject-227">
      <path
        d="M214.67,142.92v242h148.9v-242Zm136,232.3H218.82V152.61H350.65Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M214.67,142.92v242h148.9v-242Zm136,232.3H218.82V152.61H350.65Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={217.43}
        y={152.61}
        width={1.39}
        height={222.61}
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={217.43}
        y={152.61}
        width={1.39}
        height={222.61}
        fill={theme.compImgHighlight}
      />
      <path
        d="M379.18,86.27H110.43A8.79,8.79,0,0,0,101.66,95V406.75a8.79,8.79,0,0,0,8.77,8.76H379.18a8.78,8.78,0,0,0,8.76-8.76V95A8.78,8.78,0,0,0,379.18,86.27ZM218.82,152.61H350.65V375.22H218.82Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M379.18,86.27H110.43A8.79,8.79,0,0,0,101.66,95V406.75a8.79,8.79,0,0,0,8.77,8.76H379.18a8.78,8.78,0,0,0,8.76-8.76V95A8.78,8.78,0,0,0,379.18,86.27ZM218.82,152.61H350.65V375.22H218.82Z"
        opacity={0.5}
      />
      <path
        d="M376.85,86.27H108.1A8.79,8.79,0,0,0,99.33,95V406.75a8.79,8.79,0,0,0,8.77,8.76H376.85a8.79,8.79,0,0,0,8.76-8.76V95A8.79,8.79,0,0,0,376.85,86.27Zm-158,66.34H350.65V375.22H218.82Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M376.85,86.27H108.1A8.79,8.79,0,0,0,99.33,95V406.75a8.79,8.79,0,0,0,8.77,8.76H376.85a8.79,8.79,0,0,0,8.76-8.76V95A8.79,8.79,0,0,0,376.85,86.27Zm-158,66.34H350.65V375.22H218.82Z"
        opacity={0.2}
      />
      <path
        d="M99.33,108.93V406.75a8.79,8.79,0,0,0,8.77,8.76H376.85a8.79,8.79,0,0,0,8.76-8.76V108.93Zm119.49,43.68H350.65V375.22H218.82Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M99.33,108.93V406.75a8.79,8.79,0,0,0,8.77,8.76H376.85a8.79,8.79,0,0,0,8.76-8.76V108.93Zm119.49,43.68H350.65V375.22H218.82Z"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M101,120.58V403.86H384V120.58Zm249.7,254.64H218.82V152.61H350.65Z"
        style={{
          fill: "#fff",
        }}
      />
      <circle
        cx={366.38}
        cy={97.66}
        r={4.66}
        fill={theme.imageHighlight} opacity={0.76}
      />
      <circle
        cx={349.87}
        cy={97.66}
        r={4.66}
        fill={theme.imageHighlight} opacity={0.76}
      />
      <path
        d="M328.7,97.66A4.66,4.66,0,1,0,333.36,93,4.66,4.66,0,0,0,328.7,97.66Z"
        fill={theme.imageHighlight} opacity={0.76}
      />
      <rect
        x={99.33}
        y={108.34}
        width={286.27}
        height={1.17}
        transform="translate(484.94 217.85) rotate(180)"
        fill={theme.imageHighlight}
      />
      <path
        d="M391.44,142.92h-1v-7h1Zm0-13.09h-1V107h1Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M391.44,142.92h-1v-7h1Zm0-13.09h-1V107h1Z"
        opacity={0.4}
      />
      <rect
        x={148.03}
        y={200.77}
        width={28.19}
        height={14.01}
        transform="translate(324.25 415.55) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={148.03}
        y={200.77}
        width={28.19}
        height={14.01}
        transform="translate(324.25 415.55) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={127.9}
        y={293.26}
        width={52.16}
        height={14.01}
        transform="translate(307.95 600.53) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={127.9}
        y={293.26}
        width={52.16}
        height={14.01}
        transform="translate(307.95 600.53) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={131.4}
        width={107.87}
        height={14.01}
        transform="translate(269.87 276.81) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={131.4}
        width={107.87}
        height={14.01}
        transform="translate(269.87 276.81) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={154.53}
        width={87.16}
        height={14.01}
        transform="translate(249.16 323.06) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={154.53}
        width={87.16}
        height={14.01}
        transform="translate(249.16 323.06) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={177.65}
        width={99.05}
        height={14.01}
        transform="translate(261.05 369.3) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={177.65}
        width={99.05}
        height={14.01}
        transform="translate(261.05 369.3) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={200.77}
        width={55.32}
        height={14.01}
        transform="translate(217.32 415.55) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={200.77}
        width={55.32}
        height={14.01}
        transform="translate(217.32 415.55) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={223.89}
        width={99.05}
        height={14.01}
        transform="translate(261.05 461.79) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={223.89}
        width={99.05}
        height={14.01}
        transform="translate(261.05 461.79) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={247.02}
        width={107.87}
        height={14.01}
        transform="translate(269.87 508.04) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={247.02}
        width={107.87}
        height={14.01}
        transform="translate(269.87 508.04) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={270.14}
        width={76.04}
        height={14.01}
        transform="translate(238.04 554.29) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={270.14}
        width={76.04}
        height={14.01}
        transform="translate(238.04 554.29) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <rect
        x={81}
        y={293.26}
        width={35.19}
        height={14.01}
        transform="translate(197.19 600.53) rotate(180)"
        fill={theme.imageHighlight}
      />
      <rect
        x={81}
        y={293.26}
        width={35.19}
        height={14.01}
        transform="translate(197.19 600.53) rotate(180)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <circle
        cx={101.57}
        cy={350.95}
        r={23.9}
        transform="translate(-261.35 393.07) rotate(-80.48)"
        fill={theme.imageHighlight}
      />
      <circle
        cx={101.57}
        cy={350.95}
        r={23.9}
        transform="translate(-261.35 393.07) rotate(-80.48)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M104,346.79c-5.68-1.74-9.2-7.92-9.2-7.92s-1.79-.1-1.88,1.52a7.93,7.93,0,0,0,2.36,5.9l-2.73-.15a9.07,9.07,0,0,0-2.89.31l-.91.24a3,3,0,0,0-2.11,3.6L88,355.6a6.6,6.6,0,0,0,7.37,5c2.78-.41,7.11-1,7.86-1.18h0l2-.16.67-11.91Z"
        style={{
          fill: "#fff",
        }}
      />
      <rect
        x={104.17}
        y={345.14}
        width={9.81}
        height={15.68}
        rx={1.08}
        fill={theme.imageHighlight}
      />
      <circle
        cx={162.16}
        cy={350.95}
        r={23.9}
        transform="translate(-200.66 217.45) rotate(-45)"
        fill={theme.imageHighlight}
      />
      <circle
        cx={162.16}
        cy={350.95}
        r={23.9}
        transform="translate(-200.66 217.45) rotate(-45)"
        style={{
          fill: "#fff",
          opacity: 0.6000000000000001,
        }}
      />
      <path
        d="M174.07,342.4a8.42,8.42,0,0,0-11.91,0,8.42,8.42,0,0,0-11.91,11.91l11.91,11.91,11.91-11.91A8.44,8.44,0,0,0,174.07,342.4Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M207.75,142.92v242H360.33v-242Zm142.9,232.3H218.82V152.61H350.65Z"
        fill={theme.imageHighlight}
      />
      <path
        d="M207.75,142.92v242H360.33v-242Zm142.9,232.3H218.82V152.61H350.65Z"
        style={{
          fill: "#fff",
          opacity: 0.8,
        }}
      />
    </g>
  </svg>
    );
  }
}